import isEmpty from 'lodash.isempty';
import set from 'lodash.set';
import mergeWith from 'lodash.mergewith';

export function mergeShowChanges(show, changes) {
  if (isEmpty(show)) {
    return show;
  }
  if (isEmpty(changes)) {
    return show;
  }

  const merged = mergeWith({}, show);

  Object.entries(changes).forEach(([key, value]) => set(merged, key, value));
  return merged;
}

export function convertPropNameToCssSelector(propName) {
  if (isEmpty(propName)) {
    return propName;
  }
  return propName.replace('.', '-');
}
